import { ChatInputValue } from 'components/ChatInput';

/** A new object is a new request, so clicking the action again is seen as a new request. */
export type ComposerDraft = { text: string };

type ResolvedDraft = { value: ChatInputValue; keptExisting: boolean };

/**
 * Decides what the composer holds after a prefill request. Anything the provider wrote or attached
 * stays; an untouched automatic suggestion is replaced, because the provider asked for this message.
 */
export function resolveComposerDraft(
    current: ChatInputValue,
    draftText: string,
    autoSuggestion?: string,
): ResolvedDraft {
    const text = current.text.trim();
    if (text === draftText.trim() && current.files.length === 0) {
        return { value: current, keptExisting: false };
    }
    const untouched = current.files.length === 0 && (!text || current.text === autoSuggestion);
    return untouched ? { value: { text: draftText, files: [] }, keptExisting: false } : { value: current, keptExisting: true };
}
